export default __webpack_public_path__ + "static/media/copy.a8d7e85a.svg";